import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import JsonView from 'react18-json-view'
import 'react18-json-view/src/style.css'
// import 'react18-json-view/src/dark.css'
import SelectVariable from './SelectVariable'
import { cloneDeep } from 'lodash'
import { getAvailableNodesForVariable } from '../../utils/genericHelper'

export const JsonEditorInput = ({ value, onChange, inputParam, nodes, edges, nodeId, disabled = false, isDarkMode = false }) => {
    const [myValue, setMyValue] = useState(value ? JSON.parse(value) : {})
    const [availableNodesForVariable, setAvailableNodesForVariable] = useState([])
    const [mouseUpKey, setMouseUpKey] = useState('')

    const [anchorEl, setAnchorEl] = useState<any>(null)
    const openPopOver = Boolean(anchorEl)

    const handleClosePopOver = () => {
        setAnchorEl(null)
    }

    const setNewVal = (val) => {
        const newVal = cloneDeep(myValue)
        newVal[mouseUpKey] = val
        onChange(JSON.stringify(newVal))
        setMyValue((params) => ({
            ...params,
            [mouseUpKey]: val
        }))
    }

    // const onClipboardCopy = (e) => {
    //     const src = e.src
    //     if (Array.isArray(src) || typeof src === 'object') {
    //         navigator.clipboard.writeText(JSON.stringify(src, null, '  '))
    //     } else {
    //         navigator.clipboard.writeText(src)
    //     }
    // }

    useEffect(() => {
        if (!disabled && nodes && edges && nodeId && inputParam) {
            const nodesForVariable = inputParam?.acceptVariable ? getAvailableNodesForVariable(nodes, edges, nodeId, inputParam.id) : []
            setAvailableNodesForVariable(nodesForVariable)
        }
    }, [disabled, inputParam, nodes, edges, nodeId])

    return (
        <>
            <div className="mt-2 w-96">
                {disabled ? (
                    <JsonView 
                        src={myValue} 
                        theme='github' 
                        enableClipboard={true}

                    />
                    // <ReactJson
                    //     theme={isDarkMode ? 'ocean' : 'rjv-default'}
                    //     style={{ padding: '10px', borderRadius: '10px' }}
                    //     src={myValue}
                    //     name={null}
                    //     enableClipboard={(e) => onClipboardCopy(e)}
                    //     quotesOnKeys={false}
                    //     displayDataTypes={false}
                    // />
                ) : (
                    <div key={JSON.stringify(myValue)}>
                        <JsonView 
                            src={myValue} 
                            onAdd={() => {
                                    //console.log(add)
                                }}
                            onEdit={(edit) => {
                                setMyValue(edit.newValue)
                                onChange(JSON.stringify(edit.newValue))
                            }}
                            onDelete={(deleteobj: any) => {
                                setMyValue(deleteobj.updated_src)
                                onChange(JSON.stringify(deleteobj.updated_src))
                            }}
                            enableClipboard={true}
                            style={{ padding: '10px', borderRadius: '10px' }}

                        />
                        {/* <ReactJson
                            theme={isDarkMode ? 'ocean' : 'rjv-default'}
                            style={{ padding: '10px', borderRadius: '10px' }}
                            src={myValue}
                            name={null}
                            quotesOnKeys={false}
                            displayDataTypes={false}
                            enableClipboard={(e) => onClipboardCopy(e)}
                            onMouseUp={(event) => {
                                if (inputParam?.acceptVariable) {
                                    setMouseUpKey(event.name)
                                    setAnchorEl(event.currentTarget)
                                }
                            }}
                            onEdit={(edit) => {
                                setMyValue(edit.updated_src)
                                onChange(JSON.stringify(edit.updated_src))
                            }}
                            onAdd={() => {
                                //console.log(add)
                            }}
                            onDelete={(deleteobj) => {
                                setMyValue(deleteobj.updated_src)
                                onChange(JSON.stringify(deleteobj.updated_src))
                            }}
                        /> */}
                    </div>
                )}
            </div>
            {inputParam?.acceptVariable && (
                <div 
                    className={`absolute z-10 ${openPopOver ? 'block' : 'hidden'}`} 
                    style={{ top: anchorEl?.offsetTop + anchorEl?.offsetHeight, left: anchorEl?.offsetLeft }}
                >
                    <SelectVariable
                        disabled={disabled}
                        availableNodesForVariable={availableNodesForVariable}
                        onSelectAndReturnVal={(val) => {
                            setNewVal(val)
                            handleClosePopOver()
                        }}
                    />
                </div>
            )}
        </>
    )
}

JsonEditorInput.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    isDarkMode: PropTypes.bool,
    inputParam: PropTypes.object,
    nodes: PropTypes.array,
    edges: PropTypes.array,
    nodeId: PropTypes.string
}
